var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M28 17.5a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm.359 2.5h-.948c-.202 0-.366.137-.366.306v.78c-1.213.296-1.997 1.087-1.997 2.12 0 1.14.923 1.994 2.755 2.532 1.289.38 1.39.675 1.39 1.013 0 .211 0 .78-1.175.78-.594 0-1.25-.337-1.656-.6a.51.51 0 00-.581.031l-.657.56c-.177.157-.165.4.038.537.392.264 1.074.654 1.882.844v.791c0 .17.165.306.367.306h.947c.203 0 .367-.137.367-.306v-.727C30.128 28.787 31 27.953 31 26.75c0-1.656-1.82-2.194-2.59-2.426-1.555-.464-1.555-.918-1.555-1.118 0-.665.91-.728 1.188-.739.43-.01.86.158 1.15.317.177.094.417.073.556-.064l.631-.57c.177-.158.152-.421-.063-.548a4.701 4.701 0 00-1.592-.59v-.707c0-.17-.164-.306-.366-.306z",
    id: "admon_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#515864",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.143 28.571A3.439 3.439 0 0113.714 32a3.428 3.428 0 01-3.428-3.429zM13.714 0c1.423 0 2.572 1.067 2.572 2.39v1.083C21.189 4.556 24 8.65 24 13.54v3.957a8.499 8.499 0 00-4.403 8.787H0v-1.592l3.429-3.187v-7.965c0-4.907 2.794-8.985 7.714-10.068V2.39c0-1.323 1.148-2.39 2.571-2.39z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#admon_svg__a"
  }))));
}
export default SvgAdmon;